// extracted by mini-css-extract-plugin
export default {"container":"LeftSide_container__aWTGS"};